<template>
  <v-snackbar top :timeout="timeout" v-model="state" vertical :color="color">
    <div class="text-center">{{info}}</div>
  </v-snackbar>
</template>

<script>
import EventBus from "../EventBus";
import { setTimeout } from "timers";

const BLUE = "blue darken-4";
const RED = "red darken-2";
const ORANGE = "orange darken-4";
const GREEN = "green darken-2";

export default {
  name: "snackbar",
  data: function() {
    return {
      timeout: 2000,
      state: false,
      info: "",
      color: BLUE
    };
  },
  mounted() {
    EventBus.$on("OpenSnackBar", d => {
      // force animate when there is a new message
      if (this.state) {
        this.state = false;
        setTimeout(() => this.set(d), 100);
      } else {
        this.set(d);
      }
    });
  },
  methods: {
    set(d) {
      this.color = d.error ? RED : d.success ? GREEN : d.warning? ORANGE : BLUE;
      this.state = true;
      this.info = d.m;
    }
  }
};
</script>

 <br>